import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { HelmetProvider } from 'react-helmet-async';
import { ErrorBoundary } from 'react-error-boundary';
import App from './App';
import I18nProvider from './providers/I18nextProvider';
import ReactQueryClientProvider from './components/ReactQueryClientProvider';
import { ThemeProvider } from './components/theme-provider';
import theme from './theme/themeConfig';
import './sentry.config';
import './styles/global.css';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
    });
  });

  navigator.serviceWorker.getRegistration().then((registration) => {
    if (registration) {
      registration.unregister();
    }
  });

  navigator.serviceWorker.register = function () {
    console.warn(
      'Service Worker registration is disabled. PWA support is not enabled.'
    );
    return Promise.reject(new Error('Service Worker registration is disabled'));
  };
}

// Error Fallback Component
const ErrorFallback = ({ error }: { error: Error }) => (
  <div className="flex items-center justify-center min-h-screen bg-background">
    <div className="text-center p-8">
      <h1 className="text-2xl font-bold text-red-600 mb-4">Bir hata oluştu</h1>
      <p className="text-text-primary mb-4">{error.message}</p>
      <button
        onClick={() => window.location.reload()}
        className="px-4 py-2 bg-primary text-white rounded hover:bg-primary-dark"
      >
        Sayfayı Yenile
      </button>
    </div>
  </div>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <HelmetProvider>
        <BrowserRouter>
          <ConfigProvider theme={theme}>
            <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
              <I18nProvider>
                <ReactQueryClientProvider>
                  <App />
                </ReactQueryClientProvider>
              </I18nProvider>
            </ThemeProvider>
          </ConfigProvider>
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
